import { ReactNode, useEffect } from 'react';
import { ThemeProvider } from '@mui/material';

import useSidebarStore from '@/store/sidebar';
import theme, { kompaktTheme } from './index';
import { useKleinerBildschirm } from './kleinerBildschirm';
import { FARBMODUS_SCHLUESSEL } from './farbschema';

/**
 * Waehlt das Theme nach Fensterbreite (Kompakt-Modus, Decision #247): unter
 * der Schwelle die kompakte Dichte, sonst das Theme wie bisher.
 *
 * Beim Wechsel in den kleinen Bildschirm klappt die Sidebar einmal ein.
 * Auf-/Zuklappen per Hand geht danach weiter wie gewohnt.
 *
 * Dark Mode (Decision #248): dieser Provider ist der EINZIGE Wurzel-Provider
 * und damit Traeger von `useColorScheme` (Konto-Menue). Standard Hell, Wahl im
 * Browser unter `FARBMODUS_SCHLUESSEL`; `noSsr` liest sie schon beim ersten
 * Rendern (das Ladeskript in `public/index.html` hat das Attribut da bereits
 * gesetzt), `disableTransitionOnChange` schaltet ohne Ueberblendung.
 */
const DichteThemeProvider = ({ children }: { children: ReactNode }) => {
  const kleinerBildschirm = useKleinerBildschirm();

  useEffect(() => {
    if (kleinerBildschirm) {
      useSidebarStore.setState({ isExpanded: false, expandedGroups: [] });
    }
  }, [kleinerBildschirm]);

  return (
    <ThemeProvider
      theme={kleinerBildschirm ? kompaktTheme : theme}
      defaultMode="light"
      modeStorageKey={FARBMODUS_SCHLUESSEL}
      disableTransitionOnChange
      noSsr
    >
      {children}
    </ThemeProvider>
  );
};

export default DichteThemeProvider;
